import { error, type Load } from '@sveltejs/kit';
import { load as loadProduct } from '@glimja/storefront/pages/product';
import { checkAndRedirectProductUrl } from '../../../lib/utils/product-redirect';

export const load = async (event: Load) => {
  const { url } = event;

  // Check if the URL uses the correct localized path and redirect if needed
  checkAndRedirectProductUrl(url);

  try {
    const data = await loadProduct(event as unknown as any);
    return data;
  } catch (e) {
    error(404, 'Not found');
  }
};
